import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";

import { selectFooterPages } from "./../../selectors.js";

import "./style.css";
import Ka_logo from "./../../images/ka_logo.png";
import kirke_logo from "./../../images/den_norske_kirke.png";
import MapWrapper from "./../../containers/MapWrapper";

class Footer extends Component {
    renderFooterLinks() {
        const { pages } = this.props;

        return pages.map(({ sys, fields }) => (
            <p key={sys.id}>
                <Link className="footer-links__link" to={`/page/${sys.id}`}>
                    {fields.pageTitle}
                </Link>
            </p>
        ));
    }

    render() {
        const { pages } = this.props;

        return (
            <div>
                {this.props.currentKey !== "kirke" && <MapWrapper />}
                <footer className="footer">
                    <div className="container footer-inner">
                        <div className="footer-links">
                            {pages && this.renderFooterLinks()}
                        </div>
                        <div className="footer-images">
                            <div className="footer-images__image">
                                <a
                                    href="https://www.ka.no"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="KA logo"
                                >
                                    <img 
                                        src={Ka_logo} 
                                        alt="KA logo"
                                    />
                                </a>
                            </div>
                            <div className="footer-images__image">
                                <a
                                    href="https://kirken.no/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Den norske kirke logo"
                                >
                                    <img
                                        src={kirke_logo}
                                        alt="Den norske kirke logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    pages: selectFooterPages(),
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer/index.js